import axios from '../axios'

const getCode = data => axios({
  url: '/customer/recycle/order/sendEmailCode',
  method: 'post',
  data
})

const verifyCode = data => axios({
  url: '/customer/recycle/order/verifyEmailCode',
  method: 'post',
  data
})
const getCountries = params => axios({
  url: '/customer/recycle/order/getAllCountryCode',
  method: 'get',
  params
})
const getPostCode = params => axios({
  url: '/customer/recycle/order/getPagePostCode',
  method: 'get',
  params
})
const getCities = params => axios({
  url: '/customer/recycle/order/getPlaceNameByCountryCodeAndPostCode',
  method: 'get',
  params
})
const successOrder = data => axios({
  url: '/customer/recycle/order/submit',
  method: 'post',
  data
})

export {
  getCities,
  getCode,
  getCountries,
  getPostCode,
  successOrder,
  verifyCode}
